import styled from 'styled-components';
import { Pagination, PaginationVariant } from 'ui/pagination';
import { PageSize } from 'ui/pageSize';
import { body2, colors, spacing } from 'ui/theme';
import { TABLE_PAGE_SIZES } from '../constants';
import { MergedCustomEvent } from '../types';
import { usePagination } from '../hooks';

const PaginationContainer = styled.div`
  ${body2}
  border-top: ${spacing.single} solid ${colors.grey15};
  color: ${colors.textSecondary};
  display: flex;
  justify-content: space-between;
  padding: ${spacing.double} ${spacing.x3};
`;

type Props = {
  sortedEvents: MergedCustomEvent[];
  setPaginatedSortedEvents: (value: MergedCustomEvent[]) => void;
};

export const CustomEventsPagination = ({ sortedEvents, setPaginatedSortedEvents }: Props) => {
  const totalEvents = sortedEvents.length;
  const { pageSize, setPageSize, currentPage, setCurrentPage } = usePagination(
    sortedEvents,
    setPaginatedSortedEvents,
  );

  return (
    <PaginationContainer>
      <span>{totalEvents} total</span>
      <Pagination
        pages={Math.ceil(totalEvents / pageSize)}
        onChangePage={setCurrentPage}
        page={currentPage}
        variant={PaginationVariant.Grey}
      />
      <PageSize
        total={totalEvents}
        onSelect={(size) => {
          setPageSize(size);
          setCurrentPage(1);
        }}
        pageSizes={TABLE_PAGE_SIZES}
      />
    </PaginationContainer>
  );
};
